import {isEmpty} from './JSHelper';
import {CENTRAL_ACCOUNT_ID} from './Constants';

export enum StorageKeys {
  ACTIVE_ACCOUNT_ID = 'active_account_id',
  ABBREVIATE_CURRENCY = 'abbreviate_currency',
  AUTH_JWT_ACCESS_TOKEN = 'auth_jwt_access_token',
  UI_LEDGER_SINCE = 'ui_ledger_since',
  UI_LEDGER_START_DATE = 'ui_ledger_start_date',
  UI_LEDGER_END_DATE = 'ui_ledger_end_date',
  UI_LEDGER_PSP = 'ui_ledger_psp',
}

const DEFAULTS: Record<string, any> = {
  [StorageKeys.ACTIVE_ACCOUNT_ID]: CENTRAL_ACCOUNT_ID,
  [StorageKeys.ABBREVIATE_CURRENCY]: true,
  [StorageKeys.AUTH_JWT_ACCESS_TOKEN]: '',
  [StorageKeys.UI_LEDGER_SINCE]: 'quarter',
  [StorageKeys.UI_LEDGER_PSP]: '',
};

const toKey = (key: string) => `payout_dashboard_${key}`;

export const getStorageItem = (key: string): any => {
  let result = window.localStorage.getItem(toKey(key));
  return isEmpty(result) ? DEFAULTS[key] : JSON.parse(result);
};

export const putStorageItem = (key: string, value: any) => window.localStorage.setItem(toKey(key), JSON.stringify(value));

export const removeStorageItem = (key: string) => window.localStorage.removeItem(toKey(key));
